import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconCmdClick({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M7.34 9.843v3.517H5.833c-1.62 0-2.932 1.272-2.932 2.902a2.934 2.934 0 0 0 5.01 2.08 2.933 2.933 0 0 0 .855-2.08v-1.497h3.466v1.497a2.934 2.934 0 1 0 5.865 0c0-1.63-1.313-2.902-2.933-2.902h-1.497V9.843h1.497c1.62 0 2.933-1.271 2.933-2.902a2.934 2.934 0 0 0-5.01-2.078 2.934 2.934 0 0 0-.855 2.079v1.497H8.766V6.941a2.934 2.934 0 0 0-5.008-2.079A2.934 2.934 0 0 0 2.9 6.94c0 1.63 1.312 2.902 2.932 2.902H7.34v.001zM5.833 8.46c-.82 0-1.507-.687-1.507-1.518 0-.83.687-1.507 1.507-1.507.82 0 1.507.677 1.507 1.507V8.46H5.833zm9.331 0h-1.497V6.941c0-.83.677-1.507 1.497-1.507.82 0 1.508.677 1.508 1.507 0 .831-.688 1.518-1.508 1.518v.001zm-6.398 4.922V9.823h3.466v3.558H8.766v.001zm-2.933 1.353H7.34v1.518c0 .83-.687 1.507-1.507 1.507-.82 0-1.507-.677-1.507-1.507 0-.83.687-1.518 1.507-1.518zm9.331 0c.82 0 1.508.687 1.508 1.518 0 .83-.688 1.507-1.508 1.507-.82 0-1.497-.677-1.497-1.507v-1.518h1.497zm7.98-.194c0 .502.389.881.84.881.451 0 .83-.41.83-.84v-2.41l-.174-4.03 1.344 1.548 7.66 7.66a.81.81 0 0 0 .574.246c.461 0 .871-.43.871-.871a.84.84 0 0 0-.256-.575l-7.65-7.66-1.538-1.322 4.06.144h2.37c.43 0 .83-.38.83-.82a.846.846 0 0 0-.872-.842h-7.998c-.543 0-.892.37-.892.893l.001 7.998z"/>
        </svg>
    );
}

export default IconCmdClick;
